// Read the complete statement, never the filtered or display-mapped transaction rows.
export const getStatementSummary = (statement, language) => {
  const transactions = statement.transactions || [];
  const receiptChecksums = new Set((statement.expenses || []).map((expense) => expense.checksum).filter(Boolean));
  const matched = transactions.filter((transaction) => transaction.checksum && receiptChecksums.has(transaction.checksum)).length;
  const submitted = transactions.filter((transaction) => transaction.submitted === true).length;
  const lastFour = String(statement.account_mask || '').match(/\d{4}$/)?.[0];
  const currency = statement.currency_code || '';
  const amount = statement.total_with_tax;
  const hasAmount = amount !== null && amount !== undefined && amount !== '' && Number.isFinite(Number(amount));
  const options = { minimumFractionDigits: 2, maximumFractionDigits: 2 };
  if (/^[A-Z]{3}$/.test(currency)) {
    Object.assign(options, { style: 'currency', currency, currencyDisplay: 'narrowSymbol' });
  }
  return {
    count: transactions.length,
    matched,
    submitted,
    maskedCard: lastFour ? `•••• ${lastFour}` : '—',
    currency,
    total: hasAmount ? new Intl.NumberFormat(language === 'fr' ? 'fr-CA' : 'en-CA', options).format(Number(amount)) : '—',
  };
};
